//
// sortCases
//
// Order cases the way back-town's listAll ORDER BY does, so client-side merges
// (single-case upserts, non-destructive full reloads) keep the list in server
// order without needing a fresh full reload. sortBy is the [{ key, desc }] list;
// each key is also the row field name (the endpoint's outer ORDER BY sorts by
// those same result columns).
//
// MySQL orders NULL as the lowest value; mirror that so an updated case lands
// where the server would put it.
//
const compareValues = (valueA, valueB) => {
  if (valueA === valueB) return 0;
  if ((valueA === null) || (valueA === undefined)) return -1;
  if ((valueB === null) || (valueB === undefined)) return 1;
  if ((typeof valueA === 'number') && (typeof valueB === 'number')) return valueA - valueB;
  return String(valueA).localeCompare(String(valueB));
};

const sortCases = (cases, sortBy) => {
  if (!(sortBy?.length)) return cases;

  const sorted = [...cases];
  sorted.sort((caseA, caseB) => {
    for (let i = 0; i < sortBy.length; i += 1) {
      const { key, desc } = sortBy[i];
      const cmp = compareValues(caseA[key], caseB[key]);
      if (cmp !== 0) return (desc) ? (-cmp) : cmp;
    }
    return 0;
  });
  return sorted;
};

export default sortCases;
